import _ from 'lodash';

export type FriendlyNameSpec = {
  [string]: string
};
export type FriendlyOrdered = Array<FriendlyNameSpec>;
export type FriendlyUnordered = Object;

class FriendlyNames {
  arrFn: FriendlyOrdered = [];
  fnOnly: boolean = false;

  constructor(arrFn: FriendlyOrdered = [], fnOnly: boolean = false) {
    this.arrFn = arrFn;
    this.fnOnly = fnOnly;
  }

  static toArray(obj: Object): Array<Object> {
    return _.map(_.toPairs(obj), pair => _.fromPairs([pair]));
  }

  static toObject(arr: Array<Object>): Object {
    //$FlowFixMe
    return _.reduce(arr, _.assign, {});
  }

  applyToArray = (arrData: Array<Object> = []): Array<Object> => {
    let arrReturn: FriendlyOrdered = arrData;

    if (!_.isEmpty(arrData)) {
      const objData: Object = FriendlyNames.toObject(arrData);

      if (_.isEmpty(this.arrFn)) {
        arrReturn = arrData;
      } else {
        // Convert arrFn [{k1:v1},{k2,v2},...] to {k1:v1,k2:v2,...}
        const fnObj: {
          [string]: string
        } = FriendlyNames.toObject(this.arrFn);

        // Create a { field: { fn: val} ...} object,
        // If onlyFriendlyNames, the keys of all non friendly mappable keys is
        // set to undefined and then the undefined key is deleted.
        let fnMap = _.mapValues(objData, (val, key) => {
          // create and return a value object { [fn | undefined | key] : val }
          return {
            [_.get(fnObj, key, this.fnOnly ? undefined : key)]: val
          };
        });
        // Get rid of the object with the undefined fn key, if any
        fnMap = _.pickBy(fnMap, val => !_.has(val, undefined));

        // Map through friendlyNames (to maintain order), pulling the {fn:val}
        // mapping from fnMap.
        arrReturn = _.map(this.arrFn, obj => fnMap[_.keys(obj)[0]]);

        // Pick the unfriendly mappable objects from fnMap, if any
        const unMap = _.pickBy(
          fnMap,
          (val: any, key: string) => !_.has(fnObj, key)
        );

        // add the unmappable {fn:val} objects from unMap to the end of arrReturn
        arrReturn = _.unionWith(arrReturn, _.values(unMap), _.isEqual);

        // Filter out anything that isn't an object
        arrReturn = _.filter(arrReturn, _.isObject);
      }
    }

    return arrReturn;
  };

  applyToObject = (objData: Object = {}): Object => {
    let objReturn: Object = objData;

    if (!_.isEmpty(objData)) {
      const arrData: FriendlyOrdered = FriendlyNames.toArray(objData);

      const arrReturn: FriendlyOrdered = this.applyToArray(arrData);

      objReturn = FriendlyNames.toObject(arrReturn);
    }

    return objReturn;
  };

  applyTo = (data: Array<Object> | Object = {}): Object | Array<Object> => {
    let valReturn: Array<Object> | Object = data;

    if (_.isArray(data)) {
      // FriendlyOrdered
      data = data || [];
      //$FlowFixMe
      valReturn = this.applyToArray(data);
    } else if (_.isObject(data)) {
      // FriendlyUnordered
      data = data || {};
      //$FlowFixMe
      valReturn = this.applyToObject(data);
    }

    return valReturn;
  };
}

function friendlyNames(
  fns: FriendlyOrdered | FriendlyUnordered = [],
  fnOnly: boolean = false
): FriendlyNames {
  //$FlowFixMe
  const arrFn: FriendlyOrdered = _.isArray(fns)
    ? fns //$FlowFixMe
    : FriendlyNames.toOrdered(fns);

  return new FriendlyNames(arrFn, fnOnly);
}
friendlyNames.toArray = FriendlyNames.toArray;
friendlyNames.toObject = FriendlyNames.toObject;

export default friendlyNames;
